export const environment = {
  production: false,
  authUrl: `https://login-hml.ciadofrete.com.br`,
  sistemasUrl: `https://sistemas-hml.ciadofrete.com.br/`,
  tokenRefreshHours: 1,
  cookieName: 'UserCredentials_HML'
};
